import request from "@/utils/request";
import { parseStrEmpty } from "@/utils/ruoyi";

// 查询用户列表
export function listUser(query) {
  return request({
    url: "/system/user/list",
    method: "get",
    params: query,
  });
}

// 查询索引用户列表
export function getIndexedUsers() {
  return request({
    url: "/oa/pyletter/list-indexed",
    method: "get",
  });
}

// 查询用户详细
// export function getUserInfo() {
//   return request({
//     url: "/system/user/self",
//     method: "get",
//   });
// }

export const getUserInfo = () => {
  return request({
    url: "/system/user/profile",
    method: "get",
  });
}

// 新增用户
export function addUser(data) {
  return request({
    url: "/system/user/add",
    method: "post",
    data: data,
  });
}

// 修改用户
export function updateUser(data) {
  return request({
    url: "/system/user/update",
    method: "post",
    data: data,
  });
}

// 删除用户
export function delUser(userId) {
  return request({
    url: "/system/user/del/" + userId,
    method: "get",
  });
}

// 用户密码重置
export function resetSelfPwd(data) {
  return request({
    url: "/system/user/resetSelfPwd",
    method: "post",
    data: data,
  });
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status,
  };
  return request({
    url: "/system/user/changeStatus",
    method: "post",
    data: data,
  });
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: "/system/user/profile",
    method: "get",
  });
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: "/system/user/profile/update",
    method: "post",
    data: data,
  });
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword,
  };
  return request({
    url: "/system/user/profile/updatePwd",
    method: "post",
    params: data,
  });
}

// 用户找回密码
export function updatePwdWithoutOld(newPassword) {
  const data = {
    newPassword,
  };
  return request({
    url: "/system/user/profile/updatePwdWithoutOld",
    method: "post",
    params: data,
  });
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: "/system/user/authRole/" + userId,
    method: "get",
  });
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: "/system/user/authRole",
    method: "post",
    params: data,
  });
}

// 查询部门下拉树结构
export function deptTreeSelect() {
  return request({
    url: "/system/user/deptTree",
    method: "get",
  });
}

//修改用户信息API
export const updateUserProfileAPI = (data) => {
  return request({
    url: '/system/user/profile/edit',
    method: 'post',
    data
  })
}

//修改手机号
export const changePhoneAPI = (params) => {
  return request({
    url: '/system/user/changePhoneNumber/verifyCode',
    method: 'get',
    params
  })
}